import apiClient from "./apiClient";
import { PRODUCTS_PAGE_SIZE } from "./productsConstants";
import { getFilteredProducts } from "./ProductsFilter";

export { PRODUCTS_PAGE_SIZE };

const toArray = (data) => {
  if (!data) return [];
  return Array.isArray(data) ? data : [data];
};

/** Lazy store access — avoids circular import with AppRoutes/lazy pages. */
const getStore = () => require("../index").default;

const dispatchProductPage = (products) => {
  const store = getStore();
  const list = toArray(products);
  store.dispatch({ type: "GET_PRODUCTS", products: list });
  store.dispatch({
    type: "GET_ACTIVE_PRODUCTS",
    active_products: getFilteredProducts(list, "active"),
  });
  store.dispatch({
    type: "GET_ARCHIVED_PRODUCTS",
    archived_products: getFilteredProducts(list, "archived"),
  });
  store.dispatch({
    type: "GET_DRAFT_PRODUCTS",
    draft_products: getFilteredProducts(list, "draft"),
  });
  return list;
};

/** Fetch one page of products — does not crawl further pages. */
export const fetchProductsPage = async ({
  start = 0,
  size = PRODUCTS_PAGE_SIZE,
  status = "All",
  context = "Loading Products",
  silent = false,
} = {}) => {
  const params = new URLSearchParams();
  params.set("start", String(start));
  params.set("size", String(size));
  if (status) params.set("status", status);
  const data = await apiClient.get(`/products?${params.toString()}`, {
    context,
    silent,
    hideLoader: silent,
  });
  return toArray(data);
};

/**
 * Load the first products page into Redux (replace, do not accumulate all pages).
 */
export const refreshProductsInStore = async () => {
  const products = await fetchProductsPage({
    start: 0,
    size: PRODUCTS_PAGE_SIZE,
    status: "All",
    context: "Refreshing Products",
    silent: true,
  });
  return dispatchProductPage(products);
};

/**
 * Patch / insert one product in Redux after a successful API response / search hit.
 * Keeps Active/Draft slices in sync so Products list tabs show search hits beyond page 1.
 */
export const upsertProductInStore = (product) => {
  if (!product) return;
  const store = getStore();
  const normalized = {
    ...product,
    POID: product.POID || product.id || product.poid,
    id: product.id || product.POID || product.poid,
    status: product.status || product.lifeCycleStatus || "Active",
  };
  if (!normalized.POID) return;

  store.dispatch({ type: "POST_PRODUCTS", products: normalized });

  const status = String(normalized.status || "").toLowerCase();
  if (status === "active") {
    store.dispatch({ type: "POST_ACTIVE_PRODUCTS", active_product: normalized });
  } else if (status === "draft") {
    store.dispatch({ type: "POST_DRAFT_PRODUCTS", draft_product: normalized });
  } else if (status === "archived") {
    store.dispatch({ type: "POST_ARCHIVED_PRODUCTS", archived_products: normalized });
  }
};
